import { render, staticRenderFns } from "./addInsurerTB.vue?vue&type=template&id=6b703026&scoped=true"
import script from "./addInsurerTB.vue?vue&type=script&lang=js"
export * from "./addInsurerTB.vue?vue&type=script&lang=js"
import style0 from "./addInsurerTB.vue?vue&type=style&index=0&id=6b703026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b703026",
  null
  
)

export default component.exports